export default __webpack_public_path__ + "static/media/gerber_daisy.8eecd5c6.png";